<template>
    <div>
        <el-card class="common-margin">
            <common-top-form :model="formModel" :show="false" :submitService="submitService" :submitData="submitData" @success="onSuccess">
                <el-row>
                    <el-form-item label="机构简称">
                        <el-select v-model="formModel.tatSimpleId">
                            <el-option
                                v-for="item in topTatSimpleNames"
                                :key="item.id"
                                :label="item.simpleName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="路线名称">
                        <el-select v-model="formModel.shortName" style="width: 300px">
                            <el-option
                                v-for="item in topShortNames"
                                :key="item.id"
                                :label="item.shortName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-form-item label="默认时间">
                    <el-select v-model="formModel.defaultTime">
                        <el-option
                            v-for="item in timeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="交易时间">
                    <el-date-picker
                        v-model="time"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </common-top-form>
        </el-card>
        <el-card class="common-margin">
            <p class="commonTitle">交易笔数走势图</p>
            <daily-number-chart ref="rjybs" :params="DailyNumber"></daily-number-chart>
            <p class="commonTitle">交易金额走势图</p>
            <daily-money-chart ref="rjyje" :params="DailyNumber"></daily-money-chart>
        </el-card>
    </div>

</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import DailyNumberChart from '../../fragment/echarts/DailyNumberChart'
    import DailyMoneyChart from '../../fragment/echarts/DailyMoneyChart'

    import StatisticsService from 'service/StatisticsService'
    import OrganService from 'service/OrganService'
    import ChannelRateService from 'service/ChannelRateService'
    import privateKey from 'service/constant/privateKey';
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "DailyStatistics",
        components:{
            DailyNumberChart,
            CommonTopForm,
            DailyMoneyChart
        },
        data(){
            return{
                formModel:{
                    tatSimpleId:'',
                    shortName:'',
                    defaultTime:'7',
                },
                tatSimpleNames: [],
                topTatSimpleNames: [],
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                shortNames: [],
                topShortNames: [],
                allShortName: [{
                    id: '',
                    shortName: '全部'
                }],
                submitService:StatisticsService.getdaily,
                timeList:[{
                    value:'1',
                    label:'昨天',
                },{
                    value:'7',
                    label:'最近一周',
                },{
                    value:'30',
                    label:'最近一个月',
                },],
                time:[],
                DailyNumber:[],
            }
        },
        mixins: [loadMixin, dialogMixin],
        computed:{
            submitData(){

                if (this.time == null || this.time == '') {
                    this.time = [];
                }
                const params = {
                    tatSimpleId : this.formModel.tatSimpleId,
                    shortName : this.formModel.shortName,
                    defaultTime : this.formModel.defaultTime,
                };
                if (this.time.length) {
                    params.startTime = this.time[0];
                    params.endTime = this.time[1];
                }
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId']),
        },
        mounted() {
            this.getSimpleNames();

            this.getShortNames('', (res) => {
                this.topShortNames = [...this.allShortName, ...res];
            });
            this.getList();
            window.addEventListener('resize', this.chartResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.chartResize);
        },
        methods:{
            //调整窗口
            chartResize() {
                this.$refs.rjybs.charts.resize();
                this.$refs.rjyje.charts.resize();
            },
            getList(){
                this.doLoad(StatisticsService.getdaily, this.submitData, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.DailyNumber = result;
                    });
                }, '信息获取失败')
            },
            onSuccess(res){
                const result = res.contents;
                this.DailyNumber = result;
            },
            getSimpleNames() {
                this.doLoad(OrganService.simpleNames, '', res => {
                    this.doCheck(res, res => {
                        this.tatSimpleNames = res.contents;
                        this.topTatSimpleNames = [...this.all, ...this.tatSimpleNames];
                    });
                }, '信息获取失败')
            },
        },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/StatisticsManage/DailyStatistics.vue